import MuiTextField from '@mui/material/TextField';
import React, {memo} from 'react';

import {FieldProps} from '../interfaces/field-props.interface';
import {FieldWrapperComponent} from './field-wrapper.component';

interface TextFieldIProps extends FieldProps {
  id?: string;
  value?: string;
  InputProps?: any;
}

const FIELD_NAME_DEFAULT = 'name';
const FIELD_ID_DEFAULT = `${FIELD_NAME_DEFAULT}-id`;

function TextField(props: TextFieldIProps) {
  const {
    id = FIELD_ID_DEFAULT,
    name = FIELD_NAME_DEFAULT,
    label,
    value,
    error,
    handleChange,
    handleBlur,
    InputProps,
  } = props;

  return (
    <FieldWrapperComponent {...props} name={name}>
      <MuiTextField
        fullWidth
        variant="outlined"
        aria-describedby={error ? `${name}-error-id` : undefined}
        id={id}
        value={value}
        onChange={handleChange}
        onBlur={handleBlur}
        label={label}
        InputProps={InputProps}
      />
    </FieldWrapperComponent>
  );
}

export const TextFieldComponent = memo(TextField);
